import { createClient } from '@supabase/supabase-js';

// Check for environment variables with or without VITE_ prefix
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 
                   import.meta.env.SUPABASE_URL || 
                   'https://immvtoypwvaqbqxvgygt.supabase.co';

const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 
                       import.meta.env.SUPABASE_ANON_KEY ||
                       'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImltbXZ0b3lwd3ZhcWJxeHZneWd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU4NDYyMzIsImV4cCI6MjA2MTQyMjIzMn0.utIq6du_AmJ-Z3-eGQr9Hp_ubV5h5JzukSwVrMEaH0g';

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Authentication helper functions
export const signUp = async (email: string, password: string, displayName: string) => {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        username: displayName, // Set username the same as displayName for consistency
        display_name: displayName,
      }
    }
  });
  
  return { data, error };
};

export const signIn = async (email: string, password: string) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  
  return { data, error };
};

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  return { error };
};

export const getCurrentUser = async () => {
  const { data: { user } } = await supabase.auth.getUser();
  return user;
};

export const getUserProfile = async (userId: string) => {
  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('id', userId)
    .single();
    
  return { data, error };
};

// Export types
export type User = Awaited<ReturnType<typeof getCurrentUser>>;
